import { debounce } from "lodash";

// Waits until the user stops typing, so one request is sent instead of one per key press.
export const createSearchDebounce = () => debounce((search: () => void) => search(), 300);

// Each call marks a new request as the newest and returns a check for it.
// Replies can arrive out of order, so only the newest request may update the view.
export const createLatestRequest = () => {
  let latestId = 0;
  return () => {
    const id = ++latestId;
    return () => id === latestId;
  };
};
